import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import { clearTabSession } from './tabSession';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const initialState = JSON.parse(localStorage.getItem('authState')) || {
    isAuthenticated: false,
    companyId: null,
    branchId: null,
    userId: null,
    isSuperAdmin: false,
    superCompanyId: null,
    companyName: null,
    permissions: [],
    token: null,
    roleName: null,
    branchstate: null,
    username: null,
    isAppointmentNeeded: false,
  };

  const [authState, setAuthState] = useState(initialState);
  const history = useHistory();

  const login = useCallback((companyId, branchId, userId, isSuperAdmin, superCompanyId, companyName, permissions, token, roleName, branchstate, username, isAppointmentNeeded) => {
    setAuthState((prevState) => {
      const newState = {
        ...prevState,
        isAuthenticated: true,
        companyId: companyId,
        branchId: branchId,
        userId: userId,
        isSuperAdmin: isSuperAdmin,
        superCompanyId: superCompanyId,
        companyName: companyName,
        permissions: permissions,
        token: token,
        roleName: roleName,
        branchstate: branchstate,
        username: username,
        isAppointmentNeeded: isAppointmentNeeded,

      };
      localStorage.setItem('authState', JSON.stringify(newState));
      return newState;
    });
  }, []);

  const clearAuthState = useCallback(() => {
    clearTabSession();
    setAuthState({
      isAuthenticated: false,
      companyId: null,
      branchId: null,
      userId: null,
      isSuperAdmin: false,
      superCompanyId: null,
      companyName: null,
      permissions: [],
      token: null,
      roleName: null,
      branchstate: null,
      username: null,
      isAppointmentNeeded: false,
    });

    // Clear local storage
    localStorage.removeItem('authState');
  }, []);

  const logout = useCallback(() => {
    clearAuthState();
    history.push("/"); // Redirect to the login page after logout When Using Older Navbar
    window.location.reload();
  }, [clearAuthState, history]);

  const ClearToken = useCallback(() => {
    clearAuthState();
  }, [clearAuthState, history]);

  useEffect(() => {
    localStorage.setItem('authState', JSON.stringify(authState));
  }, [authState]);

  const value = {
    ...authState,
    login,
    logout,
    ClearToken,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
